import 'angular';

angular.module('GorillaBoy.directives')
.directive('clickStreamMetrics', ['ClientMetricsService', (ClientMetricsService) => {
    const MAX_DEPTH = 4;
    const CLICK_STREAM_ATTR = "wdcsmkey";
    const CLICK_STREAM_RESOURCEID = "wdcsresourceid";
    const CLICK_STREAM_VERSIONID = "wdcsversionid";

    function getParentsPath(el: HTMLElement, remainingSteps: number) {
        if (typeof el.getAttribute == 'function' && el.getAttribute(CLICK_STREAM_ATTR)) {
            return { path: el.getAttribute(CLICK_STREAM_ATTR),
                     resourceId : el.getAttribute(CLICK_STREAM_RESOURCEID),
                     versionId : el.getAttribute(CLICK_STREAM_VERSIONID) }; //return an object, in this case. It means stop recursing
        }
        if (!el.parentElement || remainingSteps < 0) {
            return '';
        }
        const parentsPath = getParentsPath(el.parentElement, remainingSteps - 1);
        if (typeof parentsPath == 'object') {
            return parentsPath;
        }
        return  el.nodeName + '(' + el.className + ')' + (parentsPath ? ' < ' + parentsPath : '');
    }

    return {
        restrict: 'A',
        scope: false,
        link: ($scope, $element) => {
            $element.on('click', (evt: MouseEvent) => {
                const target = <HTMLElement> evt.target;
                if (!target) {
                    return;
                }
                
                let returnedValue = getParentsPath(target, MAX_DEPTH);

                if (typeof returnedValue === 'string') {
                    returnedValue = { path : returnedValue};
                }

                ClientMetricsService.addClickStreamToSession(returnedValue);
            });
        }
    };
}]);
